import {useEffect, useState} from 'react';
import KuAuthority from '@/auth/KuAuthority';
import {AuthType, AuthItem, AuthOriginValue} from './auth.td';
import {AuthResultType} from './KuAuthMap';
import * as store from '@/store';

interface SourceData {
    document?: any;
    repository?: any;
    department?: any;
}

type AuthViewKey = 'error'|'noPermission'|'isReader'|'isMember'|'isAdmin'|'isAAOwner';

// todo 类型any需要优化
const AUTH_VIEW_ARRAY: any[] = [
    'isAAOwner',
    'isAdmin',
    'isMember',
    'isReader',
    'noPermission',
    'error',
];

interface AuthView {
    isAAOwner?: (authRes: AuthResultType) => any;
    isAdmin?: (authRes: AuthResultType) => any;
    isMember?: (authRes: AuthResultType) => any;
    isReader?: (authRes: AuthResultType) => any;
    // 异常相关
    noPermission?: (authRes: AuthResultType) => any;
    error?: (authRes: AuthResultType) => any;
}

interface KuAuthProps {
    type: AuthType;
    views: AuthView;
    sourceData?: SourceData;
    storeConnectKeys?: string[];
}

function KuAuth(props: KuAuthProps) {
    const {
        type,
        views,
        sourceData,
        storeConnectKeys,
    } = props;

    const [refresh, setRefresh] = useState(Date.now());

    function handleStoreChange(newVal: any) {
        console.log('测试：KuAuth--render----store发生变化了----------');
        setRefresh(newVal);
    }

    useEffect(() => {
        if (storeConnectKeys) {
            storeConnectKeys.forEach((item: string) => store.subscribe(item, handleStoreChange));
        }
        return () => {
            if (storeConnectKeys) {
                storeConnectKeys.forEach((item: string) => store.unsubscribe(item, handleStoreChange));
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // todo 检查不满足当前权限，就按顺序使用【上一个有权限的】视图展示
    function getView() {
        let view: AuthViewKey|null = null;
        for (const key of AUTH_VIEW_ARRAY) {
            if (!Object.keys(views).includes(key)) {
                continue;
            }
            const isAuthed = KuAuthority.isAuthedByMap(type, key, sourceData);
            if (isAuthed) {
                view = key;
                break;
            }
        }
        return view;
    }

    if (!views || !Object.keys(views).length) {
        return null;
    }

    const view = getView();
    if (!view) {
        return null;
    }
    const auth = KuAuthority.getAuth(type, sourceData);
    const renderViewFn = views[view];
    return renderViewFn ? renderViewFn(auth) : null;
}

export default KuAuth;
